import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import { STAY_RESTRICTIONS_RATE_GROUP_IDS } from 'lumen/utils/constants/pricing-assistant-constants';

export interface RateGroup {
  rateGroupId: string;
  rateIds: string[];
}

export default class PaSubscriptionMetaInfo extends Model {
  [Type] = 'pa-subscription-meta-info' as const;

  @attr('dayjs') declare lastRecommendationsRefresh: DayjsTransformReturn;
  @attr('json') declare rateGroups: RateGroup[] | null;
  // Also used as id (primaryKey in the model serializer)
  @attr('number') declare subscriptionId: number;

  get deepDiscountRateGroupRateIds(): string[] {
    return (
      this.rateGroups?.find(
        (rateGroup) =>
          rateGroup.rateGroupId ===
          STAY_RESTRICTIONS_RATE_GROUP_IDS.DEEP_DISCOUNT,
      )?.rateIds ?? []
    );
  }

  get isDeepDiscountRateGroupConfigured(): boolean {
    return this.deepDiscountRateGroupRateIds.length > 0;
  }
}
